import Api from "app/services/common/Api";
import { ApiUrlUtil } from "app/utils/apiUrlUtil";
import { SysDataCollect } from "app/model/common/sysModel";

export class SysBigDataService extends Api {
  private static service: SysBigDataService;

  public static getInstance(): SysBigDataService {
    if (!SysBigDataService.service) {
      SysBigDataService.service = new SysBigDataService();
    }
    return SysBigDataService.service;
  }

  public async getHeaderData() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + '/mg/sys/003/ag');
    return await super.get<any>(url);
  }

  public async doSyncData(param: any) {
    const url: string = process.env.REACT_APP_URL_CO + '/mg/sys/003/sync';
    return await super.get<any>(url, param);
  }

  /**
   * 가장 최근 MG/MDMS 수집 시간 조회
   * (사용자별 수집된 가장 최근 데이터)
   */
  public async getLatestKPMGTime() {
    const url = process.env.REACT_APP_URL_CO + '/sys/user/data/latest-time';
    return await super.get<SysDataCollect>(url);
  }

  /**
   * 가장 최근 MG/MDMS 수집 시간 조회: 관리자용
   * (관리자용 수집된 가장 최근 데이터)
   */
  public async getAdminLatestKPMGTime() {
    const url = process.env.REACT_APP_URL_CO + '/sys/admin/data/latest-time';
    return await super.get<SysDataCollect>(url);
  }
}